import { normalizeEmail } from './assessmentAutosave';

export interface QuizNavigationState {
  prospectEmail?: string | null;
}

export function getQuizNavigationState(state: unknown): QuizNavigationState {
  if (!state || typeof state !== 'object') return {};

  const prospectEmail = (state as Record<string, unknown>).prospectEmail;
  return typeof prospectEmail === 'string' || prospectEmail === null
    ? { prospectEmail }
    : {};
}

export function getQueryProspectEmail(search?: string): string | null {
  const query = search ?? (typeof window === 'undefined' ? '' : window.location.search);
  return normalizeEmail(new URLSearchParams(query).get('email'));
}

export function getQuizProspectEmail(state: unknown, search?: string): string | null {
  return normalizeEmail(getQuizNavigationState(state).prospectEmail) ?? getQueryProspectEmail(search);
}
